// NOTE:: rename to PATHS
const MENU_PATHS = {
  HOMEPAGE: "/",
  NEWS: "/news",
  CONTACT: "/contact",
  TEAM: "/team",
  SERVICES: "/services",
  DIVE_TEAM_MEMBERS: "/services/for-dive-team-members",
  DIVING_ORGANIZATIONS: "/services/for-companies",
  ADVERTISING_AND_MARKETING: "/services/for-trade-organizations",
  DIVE_SCHOOLS: "/services/for-dive-schools",
  CLIENT_ORGANIZATIONS: "/services/for-client-organizations",
  ABOUT_US: "/about",
  PRIVACY_POLICY: "/privacy-policy",
  TERMS_OF_SERVICE: "/terms-of-service",
  PARTNERS: "/services/partners",
};

export default MENU_PATHS;
